export default "__VITE_ASSET__DYQKfPEe__"